import React from 'react'
import TileIcon from '../svg/TileIcon'
import { NavLink } from 'react-router-dom'
import './LiveTile.css'
import Conditional from './Conditional'

type LiveTileProps = {
  name: string
  to?: string
  icon?: string
}
type LiveTileState = null
class LiveTile extends React.Component<LiveTileProps, LiveTileState> {
  render() {
    const { icon = '', to = '' } = this.props
    return (
      <div className="tile">
        <Conditional if={icon}>
          <TileIcon name={icon} />
        </Conditional>
        <h3>
          <Conditional if={to}>
            <Conditional if={to.startsWith('/')}>
              <NavLink to={to}>{this.props.name}</NavLink>
            </Conditional>

            <Conditional if={!to.startsWith('/')}>
              <a href={to} target="_blank" rel="noreferrer">
                {this.props.name}
              </a>
            </Conditional>
          </Conditional>

          <Conditional if={!to}>{this.props.name}</Conditional>
        </h3>
        {this.props.children}
      </div>
    )
  }
}

export default LiveTile
